<template>
    <div class="helper">
        <img :src="'/img/icons/helper-'+type+'.svg'" class="helper__icon">
        <span :class="'helper__text helper__text--'+type">{{ text }}</span>
    </div>
</template>
<script>
    export default {
        props: ['type', 'text'],
        name: "HelperMessage"
    }
</script>